import "./Home.css";
import HomeLeftSection from "./HomeLeftSection";
import HomeRightSection from "./HomeRightSection";

// import "../../App.css";

export default function () {
  return (
    <div className="home-container">
      <div className="main">
        <HomeLeftSection />
        <HomeRightSection />
      </div>
    </div>
  );
}
